import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

import { dimensions } from "@styles";

export const wrapper = css`
  flex: 1;
  text-align: center;
`;

export const header = css`
  margin-bottom: 1rem;
`;

export const section = css`
  margin-bottom: 1rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    text-align: left;
  }
`;

export const subHeader = css`
  font-weight: ${typography.weightBase};

  @media (min-width: ${dimensions.tablet}) {
    display: block;
  }
`;

export const svg = css`
  width: 14.5rem;
  height: 14.5rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    width: 9rem;
    height: 9rem;
  }
`;
